/* Onboarding — constantes partagées, options MCQ et état initial */

export const SECTORS = [
  "BTP", "Rénovation", "Électricité", "Plomberie", "Conseil", "Coaching",
  "Tech/Logiciel", "Immobilier", "Santé", "Transport", "Commerce", "Industrie",
  "RH", "Marketing", "Finance", "Autre",
];

/* ─────────── STEP 2 — Activité & offre (12 MCQ) ─────────── */

export const PRESTATION_TYPES = [
  { v: "Devis ponctuel",  icon: "📋" },
  { v: "Forfait",         icon: "📦" },
  { v: "Contrat long",    icon: "🔁" },
  { v: "Maintenance",     icon: "🛠️" },
  { v: "Urgence",         icon: "🚨" },
  { v: "Sur-mesure",      icon: "🎯" },
  { v: "Abonnement",      icon: "📅" },
  { v: "SaaS / Logiciel", icon: "💻" },
];

export const INTERVENTION_CONTEXTS = [
  "Neuf",
  "Rénovation",
  "Urgence",
  "Maintenance périodique",
  "Gros chantier",
  "Petits travaux",
  "Conseil / Audit",
  "Formation",
];

export const CERTIFICATIONS = [
  "RGE", "Qualibat", "ISO", "Garantie décennale",
  "Artisan d'art", "Label écologique", "Agrément CIR", "Aucun",
];

export const GEO_ZONES = [
  { v: "Local <30km",   label: "Local (< 30 km)" },
  { v: "Départemental", label: "Départemental" },
  { v: "Régional",      label: "Régional" },
  { v: "National",      label: "National" },
  { v: "International", label: "International" },
];

export const PURCHASE_FREQ = [
  "Une seule fois", "Occasionnel", "Mensuel", "Trimestriel", "Annuel",
];

export const BASKET_RANGES = [
  { v: "<1k€",    label: "Moins de 1 000 €" },
  { v: "1-5k€",   label: "1 000 – 5 000 €" },
  { v: "5-20k€",  label: "5 000 – 20 000 €" },
  { v: "20-50k€", label: "20 000 – 50 000 €" },
  { v: "50k€+",   label: "Plus de 50 000 €" },
];

export const CYCLE_RANGES = [
  "Moins d'1 semaine", "1–4 semaines", "1–3 mois", "Plus de 3 mois",
];

export const PRICE_POSITIONING = [
  { v: "entrée-de-gamme", label: "Accessible" },
  { v: "milieu-de-gamme", label: "Milieu de gamme" },
  { v: "haut-de-gamme",   label: "Premium" },
];

export const ACQUISITION_CHANNELS = [
  { v: "Bouche-à-oreille", icon: "🗣️" },
  { v: "SEO",              icon: "🔍" },
  { v: "Google Ads",       icon: "📢" },
  { v: "Meta Ads",         icon: "📱" },
  { v: "LinkedIn",         icon: "💼" },
  { v: "Prospection terrain", icon: "🚶" },
  { v: "Salons",           icon: "🤝" },
  { v: "Partenaires",      icon: "🔗" },
];

export const STRENGTHS = [
  "Prix compétitif", "Réactivité", "Expertise technique", "Garanties solides",
  "Proximité", "Qualité premium", "Service client", "Innovation",
];

export const BUSINESS_CHALLENGES = [
  "Manque de leads", "Conversion faible", "Cycle trop long",
  "Concurrence agressive", "Peu de récurrence", "Marges faibles",
];

export const MATURITY_LEVELS = [
  { v: "débute",      label: "Je débute" },
  { v: "croissance",  label: "En croissance" },
  { v: "stabilisation", label: "En stabilisation" },
  { v: "scaling",     label: "En scaling" },
];

/* ─────────── STEP 3 — Client idéal (9 MCQ) ─────────── */

export const ICP_TYPES = ["Indépendant", "Micro-entreprise", "TPE", "PME", "ETI", "Grand compte", "Collectivité"];
export const ICP_SIZES = [
  { v: "1-5",     label: "1–5 salariés" },
  { v: "6-20",    label: "6–20 salariés" },
  { v: "21-100",  label: "21–100 salariés" },
  { v: "101-500", label: "101–500 salariés" },
  { v: "500+",    label: "500+ salariés" },
];

export const DECIDER_PROFILES = [
  "Gérant", "Directeur général", "DAF", "DRH", "DSI",
  "Directeur commercial", "Syndic", "Architecte", "Acheteur", "CEO / Fondateur",
];

export const BUYING_TRIGGERS = [
  "Déménagement", "Audit / Certification", "Fin de saison",
  "Fin de garantie", "Rénovation énergétique", "Perte d'un prestataire",
  "Croissance forte", "Levée de fonds", "Nouveau projet lancé",
  "Changement réglementaire", "Nouveau dirigeant",
];

export const CLIENT_PROBLEMS = [
  "Manque de réactivité des prestataires",
  "Coûts qui dérapent",
  "Qualité insuffisante",
  "Délais non respectés",
  "Communication difficile",
  "Manque de fiabilité",
  "Complexité administrative",
  "Besoin d'expertise pointue",
];

export const CLIENT_BUDGETS = [
  { v: "<5k€",    label: "Moins de 5 000 €" },
  { v: "5-20k€",  label: "5 000 – 20 000 €" },
  { v: "20-50k€", label: "20 000 – 50 000 €" },
  { v: "50-200k€", label: "50 000 – 200 000 €" },
  { v: "200k€+",  label: "Plus de 200 000 €" },
];

export const URGENCY_LEVELS = [
  { v: "immediate", label: "Immédiat (< 1 semaine)" },
  { v: "court",     label: "Court terme (< 1 mois)" },
  { v: "moyen",     label: "Moyen terme (1–3 mois)" },
  { v: "long",      label: "Long terme (> 3 mois)" },
];

export const CHOICE_CRITERIA = [
  "Prix", "Qualité", "Proximité", "Réactivité",
  "Expertise", "Recommandation", "Certification", "Service client",
];

/* ─────────── STEP 4 — Stratégie (10 MCQ) ─────────── */

export const CHANNELS = [
  { v: "Road Maps", icon: "🚶" },
  { v: "Téléphone", icon: "📞" },
  { v: "LinkedIn",  icon: "💼" },
  { v: "WhatsApp",  icon: "📱" },
  { v: "Email",     icon: "📧" },
  { v: "Mix",       icon: "🔀" },
];

export const COMM_TONES = [
  { v: "Formel",      desc: "Courrier officiel, emails soignés" },
  { v: "Semi-formel", desc: "Naturel et professionnel — l'équilibre recommandé" },
  { v: "Décontracté", desc: "Direct, chaleureux, proche du client" },
];

export const DAYS = [
  ["Mon", "Lun"], ["Tue", "Mar"], ["Wed", "Mer"],
  ["Thu", "Jeu"], ["Fri", "Ven"], ["Sat", "Sam"],
];

export const HOUR_SLOTS = [
  { v: "morning",   label: "Matin (8h–12h)" },
  { v: "afternoon", label: "Après-midi (14h–18h)" },
  { v: "evening",   label: "Soir (18h–20h)" },
];

export const MONTHLY_TARGETS = [
  { v: 2,  label: "1–3 clients / mois" },
  { v: 5,  label: "4–6 clients / mois" },
  { v: 8,  label: "7–10 clients / mois" },
  { v: 15, label: "11–20 clients / mois" },
  { v: 25, label: "Plus de 20 / mois" },
];

export const COMMON_OBJECTIONS = [
  "Trop cher",
  "J'ai déjà un prestataire",
  "Je dois réfléchir",
  "Ce n'est pas le moment",
  "Pas besoin actuellement",
  "Je ne vous connais pas",
  "Votre concurrent est moins cher",
  "Je vais comparer",
  "Budget bloqué",
  "Pas convaincu",
];

export const OBJECTION_ANSWERS = [
  "Retour sur investissement chiffré",
  "Étude de cas client similaire",
  "Garantie satisfait ou remboursé",
  "Essai gratuit / test",
  "Démo rapide personnalisée",
  "Référence client du même secteur",
  "Délai de réflexion accordé",
  "Offre modulable sur-mesure",
  "Plan de paiement échelonné",
  "Accompagnement dédié inclus",
];

export const SALES_ACTIONS = [
  "Prise de RDV",
  "Découverte / Questionnement",
  "Présentation / Démo",
  "Proposition commerciale",
  "Négociation",
  "Closing",
  "Relance",
];

/* ─────────── Step meta ─────────── */

export const STEP_META = {
  1: { title: "Votre entreprise",      sub: "Commençons par vos informations de base." },
  2: { title: "Votre activité & offre", sub: "12 questions pour que Prosperr cible exactement ce que vous vendez." },
  3: { title: "Votre client idéal",    sub: "9 questions pour identifier les bons profils à contacter." },
  4: { title: "Stratégie & canaux",    sub: "10 questions pour calibrer vos scripts et rythmes." },
};

/* ─────────── Initial form ─────────── */

export const initialForm = {
  /* Step 1 */
  company_name: "", sector: "", siret: "", zone: "Local", cities: [],
  /* Step 2 — Activité & offre */
  prestation_types: [],        // multi
  intervention_contexts: [],   // multi
  certifications: [],          // multi
  geo_intervention: "",        // single
  purchase_frequency: "",      // single
  basket_range: "",            // single
  cycle_range: "",             // single
  price_positioning: "milieu-de-gamme",  // single
  acquisition_channels: [],    // multi
  strengths: [],               // multi max 3
  main_challenge: "",          // single
  maturity_level: "",          // single
  /* Step 3 — Client idéal */
  icp_types: [],               // multi
  icp_sizes: [],               // multi
  icp_sectors: [],             // multi
  decider_profiles: [],        // multi
  buying_triggers: [],         // multi
  client_problems: [],         // multi
  client_budget: "",           // single
  urgency_level: "",           // single
  choice_criterion: "",        // single
  /* Step 4 — Stratégie */
  preferred_channel: "Mix",
  secondary_channels: [],      // multi
  communication_tone: "Semi-formel",
  prospecting_days: ["Mon", "Tue", "Wed", "Thu", "Fri"],
  prospecting_hours: "morning",
  monthly_target: 5,
  common_objections: [],       // multi max 2
  objection_answers: [],       // multi max 2
  best_action: "",             // single
  hardest_action: "",          // single
  /* Final */
  final_feedback: "",          // textarea on review
};
